import { render } from "./Section2.vue?vue&type=template&id=670e8bca"
import script from "./Section2.vue?vue&type=script&lang=js"
export * from "./Section2.vue?vue&type=script&lang=js"

import "./Section2.vue?vue&type=style&index=0&id=670e8bca&lang=css"

import exportComponent from "/Users/kimlong/Documents/Projects/Vuejs/adsota/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__